import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  imageStyle: {
    height: 40,
    width: 47,
    marginRight: 10,
  },
  container: {
    marginLeft: 0,
  },
});
